import { PAGE_SIZE } from '@/constants/categ';

type FetchCategProductsParams = {
	productsService: any;
	storeId: string;
	categId: string;
	isCUCategory: boolean;
	onlyCU?: boolean;
	page: number;
	sort: number;
	filterQuery: string;
	searchTerm?: string;
	storeIdForPrice?: string;
	ec?: boolean;
	withFilter: string;
	searchSessionId?: string;
};

export const fetchCategProducts = ({
	productsService,
	storeId,
	categId,
	isCUCategory,
	onlyCU = false,
	page,
	sort,
	filterQuery,
	searchTerm,
	storeIdForPrice,
	ec = false,
	withFilter,
	searchSessionId,
}: FetchCategProductsParams): Promise<any> => {
	if (searchTerm) {
		return productsService.getSearchProducts(
			{
				storeId,
				searchTerm,
				page: page || 1,
				size: PAGE_SIZE.LIST,
				filter: filterQuery,
				sort,
				ec,
			},
			null,
			searchSessionId,
		);
	}

	const isCU = isCUCategory || onlyCU;
	const functionToCall = isCUCategory
		? productsService.getAllBottlesProductAndCategForListingCU.bind(productsService)
		: productsService.getCategWithFiltersAndProducts.bind(productsService);

	return functionToCall(
		{
			storeId,
			categ: categId,
			page: page || 1,
			size: PAGE_SIZE.LIST_CU,
			filter: filterQuery,
			sort,
			withFilter,
			isCU,
		},
		storeIdForPrice,
	);
};
